import {configureStore} from '@reduxjs/toolkit';
import {persistReducer, persistStore} from 'redux-persist';
import createIdbStorage from 'redux-persist-indexeddb-storage';

import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import {
    BOOKING_VALID_DATES, BUSINESS_INFO,
    BUY_CLASS_RECEIPT,
    BUY_NEW_CLASS_OBJECT,
    BUY_NEW_SANS_OBJECT, BUY_SANS_RECEIPT,
    CLASS_BUY_PAGE_ID,
    CLASS_SELECTED_DATE, DIALOG_MESSAGE,
    HEADER_PORTAL_CONTAINER,
    NEW_ACCOUNT_DATA, NEW_USER_INFO,
    OBJECT_TO_BUY,
    SANS_BUY_PAGE_ID,
    SANS_SELECTED_DATE,
    SERVICE_TAB_INDEX,
    UPDATE_PASSWORD_INFO
} from "../action/type.action";
import masterReducer from '../reducer/MasterReducer';

const idbStorage = createIdbStorage(
    "onviCustomers",
    "pwaReduxStore"
);

const persistConfig = {
    key: 'root',
    storage,
    blacklist: [
        'persist/REHYDRATE',
        '_persist',
        HEADER_PORTAL_CONTAINER,
        "NO_BUSINESS_DAYS",
        CLASS_SELECTED_DATE,
        SANS_SELECTED_DATE,
        SERVICE_TAB_INDEX,
        BOOKING_VALID_DATES,
        CLASS_BUY_PAGE_ID,
        SANS_BUY_PAGE_ID,
        BUY_NEW_CLASS_OBJECT,
        BUY_NEW_SANS_OBJECT,
        OBJECT_TO_BUY,
        UPDATE_PASSWORD_INFO,
        NEW_ACCOUNT_DATA,
        BUY_CLASS_RECEIPT,
        BUY_SANS_RECEIPT,
        NEW_USER_INFO,
        BUSINESS_INFO,
        DIALOG_MESSAGE,
    ],
}

// const persistedReducer = persistReducer(persistConfig, masterReducer)
// const middleware = [thunk];
//
//
// export const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(...middleware)));
// export const persist = persistStore(store)

const persistedReducer = persistReducer(persistConfig, masterReducer);

export const store = configureStore({
                                        reducer: persistedReducer,
                                        middleware: (getDefaultMiddleware) =>
                                            getDefaultMiddleware({
                                                                     serializableCheck: false,
                                                                     immutableCheck: false,
                                                                 }).concat(thunk),
                                        devTools: process.env.NODE_ENV !== 'production',
                                    });
export const persist = persistStore(store);